import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

import { userProfileKey } from './useUpdateProfile';

const userProfileDisaableMfaKey = userProfileKey.concat('disableMFA');

export const useDisableUserMFA = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, string>
) =>
  useEitherMutation((recoveryCode) => services2.userProfileService.disableMfa(recoveryCode), {
    mutationKey: userProfileDisaableMfaKey,
    onError: (err) => {
      snackbarService.error('Could not disable MFA. Message: ', err.message);
    },
    ...options,
  });
